import { render, staticRenderFns } from "./VendorSummaryReport.vue?vue&type=template&id=a0bd2d34&"
import script from "./VendorSummaryReport.vue?vue&type=script&lang=js&"
export * from "./VendorSummaryReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports